
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/zoho-books",
      function () {
        return require("private-next-pages/whatsapp-integrations/zoho-books.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/zoho-books"])
      });
    }
  